import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchShipmentCategoriesQuery } from '@/features/shipment-categories'
import { fetchShipmentCategoriesList } from '@/features/shipment-categories/api'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'

import { ShipmentCategoriesSearchSchema } from './-models/shipment-categories-search'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/shipment-categories/'
)({
  validateSearch: (search) => parse(ShipmentCategoriesSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、選択中のDCと enable=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId,
          enable: true
        }
      })
    }

    if (search.dcId != selectedDcId) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchShipmentCategoriesQuery(tenantKey, deps)

    return {
      authUser: auth.user,
      shipmentCategories: await fetchShipmentCategoriesList(
        query,
        abortController.signal
      )
    }
  }
})
